import Letterhead from "../Reusable/Letterhead2";
import MetaInfo from "../Reusable/MetaInfo2";
import SubjectLine from "../Reusable/SubjectLine2";
import Signature from "../Reusable/Signature2";

interface AppraisalLetterProps {
  refNo: string;
  date: string;
  name: string;
  address: string;
  period: string;
  revisedSalary: string;
  effectiveDate: string;
}

const AppraisalLetter = ({
  refNo,
  date,
  name,
  address,
  period,
  revisedSalary,
  effectiveDate,
}: AppraisalLetterProps) => (
  <div className="p-10 rounded-lg max-w-2xl mx-auto leading-relaxed space-y-4">
    <Letterhead/>
    <hr className=" mx-auto w-4/4 border-t-2 border-black"/>
    <MetaInfo refNo={refNo} date={date} name={name} address={address} />
    <SubjectLine subject="Appraisal Letter" />

    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
      Based on the performance appraisal for the period <b>{period}</b>, 
      the management acknowledges your contribution,
      dedication, and commitment towards your role and responsibilities at <b>Optim Health and Wellness Pvt. Ltd.</b>
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
      In recognition of your efforts, your revised salary/package has been fixed
      at <b>Rs {revisedSalary}</b>, effective from <b>{effectiveDate}</b>. All other terms and conditions of your
      employment shall remain unchanged.
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
      We look forward to your continued dedication and valuable contribution to
      the growth of the organization.
    </p>



    <Signature />
  </div>
);

export default AppraisalLetter;
